import React from 'react';
import { formatMoney } from './accountingConstants';

export default function ProfitabilityTab({
  profitabilityData,
  profitabilityLoading,
  profDateFrom,
  setProfDateFrom,
  profDateTo,
  setProfDateTo,
  fetchProfitability
}) {
  return (
    <div>
      {/* Filtry dat */}
      <div style={{
        backgroundColor: "var(--card-bg)",
        borderRadius: '6px',
        border: '1px solid var(--border)',
        padding: '0.75rem',
        marginBottom: '1rem',
        display: 'flex',
        gap: '0.5rem',
        alignItems: 'center'
      }}>
        <span style={{ fontSize: '12px', fontWeight: 500, color: 'var(--text-secondary)' }}>Okres:</span>
        <input
          type="date"
          value={profDateFrom}
          onChange={(e) => setProfDateFrom(e.target.value)}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px' }}
        />
        <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>do</span>
        <input
          type="date"
          value={profDateTo}
          onChange={(e) => setProfDateTo(e.target.value)}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px' }}
        />
        <button
          onClick={fetchProfitability}
          style={{ padding: '6px 12px', border: '1px solid var(--success)', color: 'var(--success)' , fontSize: '12px', cursor: 'pointer' }}
        >
          {'🔄'} Odśwież
        </button>
      </div>

      {profitabilityLoading ? (
        <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>Ładowanie danych...</div>
      ) : profitabilityData ? (
        <>
          {/* KPI Cards */}
          {profitabilityData.total && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '0.75rem', marginBottom: '1.5rem' }}>
              <div style={{ background: 'linear-gradient(135deg, var(--purple), var(--purple))', color: '#fff' , padding: '1rem', borderRadius: '8px' }}>
                <div style={{ fontSize: '10px', opacity: 0.9, textTransform: 'uppercase' }}>Marża netto</div>
                <div style={{ fontSize: '20px', fontWeight: 'bold', marginTop: '4px' }}>{formatMoney(profitabilityData.total.marza_netto)}</div>
              </div>
              <div style={{ background: 'linear-gradient(135deg, #f093fb, var(--danger))', color: '#fff' , padding: '1rem', borderRadius: '8px' }}>
                <div style={{ fontSize: '10px', opacity: 0.9, textTransform: 'uppercase' }}>Koszty zewnętrzne</div>
                <div style={{ fontSize: '20px', fontWeight: 'bold', marginTop: '4px' }}>{formatMoney(profitabilityData.total.koszty_zewnetrzne)}</div>
              </div>
              <div style={{ background: 'linear-gradient(135deg, #4facfe, #00f2fe)', color: '#fff' , padding: '1rem', borderRadius: '8px' }}>
                <div style={{ fontSize: '10px', opacity: 0.9, textTransform: 'uppercase' }}>Faktury zakupowe</div>
                <div style={{ fontSize: '20px', fontWeight: 'bold', marginTop: '4px' }}>{formatMoney(profitabilityData.total.faktury_zakupowe)}</div>
              </div>
              <div style={{
                background: profitabilityData.total.status === 'dodatnia'
                  ? 'linear-gradient(135deg, #11998e, #38ef7d)'
                  : 'linear-gradient(135deg, var(--danger), var(--danger))',
                color: '#fff' , padding: '1rem', borderRadius: '8px'
              }}>
                <div style={{ fontSize: '10px', opacity: 0.9, textTransform: 'uppercase' }}>RENTOWNOŚĆ</div>
                <div style={{ fontSize: '20px', fontWeight: 'bold', marginTop: '4px' }}>{formatMoney(profitabilityData.total.rentownosc)}</div>
                <div style={{ fontSize: '12px', marginTop: '2px' }}>{(profitabilityData.total.rentownosc_procent || 0).toFixed(1)}%</div>
              </div>
            </div>
          )}

          {/* Tabela lokalizacji */}
          <div style={{ backgroundColor: "var(--card-bg)", borderRadius: '6px', border: '1px solid var(--border)', overflow: 'hidden' }}>
            <div style={{ padding: '0.75rem 1rem', background: 'var(--bg)', borderBottom: '1px solid var(--border)' }}>
              <span style={{ fontWeight: 600, fontSize: '13px' }}>{'📍'} Rentowność per lokalizacja</span>
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
              <thead>
                <tr style={{ backgroundColor: 'var(--bg)' }}>
                  <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Lokalizacja</th>
                  <th style={{ padding: '10px', textAlign: 'right', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Marża netto</th>
                  <th style={{ padding: '10px', textAlign: 'right', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Koszty zewn.</th>
                  <th style={{ padding: '10px', textAlign: 'right', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Faktury zakupowe</th>
                  <th style={{ padding: '10px', textAlign: 'right', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Rentowność</th>
                  <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {profitabilityData.locations?.map(loc => (
                  <tr key={loc.location_id} style={{ borderBottom: '1px solid var(--border)' }}>
                    <td style={{ padding: '10px' }}>
                      <div style={{ fontWeight: 500 }}>{loc.location_name}</div>
                      {loc.kod && <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{loc.kod}</div>}
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right', color: 'var(--success)' }}>{formatMoney(loc.marza_netto)}</td>
                    <td style={{ padding: '10px', textAlign: 'right', color: 'var(--danger)' }}>{formatMoney(loc.koszty_zewnetrzne)}</td>
                    <td style={{ padding: '10px', textAlign: 'right', color: 'var(--warning)' }}>{formatMoney(loc.faktury_zakupowe)}</td>
                    <td style={{ padding: '10px', textAlign: 'right', fontWeight: 600, fontSize: '13px' }}>{formatMoney(loc.rentownosc)}</td>
                    <td style={{ padding: '10px', textAlign: 'center' }}>
                      <span style={{
                        padding: '3px 10px', borderRadius: '10px', fontSize: '10px',
                        background: loc.status === 'dodatnia' ? 'var(--success-light)' : 'var(--danger-light)',
                        color: loc.status === 'dodatnia' ? 'var(--success)' : 'var(--danger)'
                      }}>
                        {(loc.rentownosc_procent || 0).toFixed(1)}%
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {(!profitabilityData.locations || profitabilityData.locations.length === 0) && (
              <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>Brak danych do wyświetlenia</div>
            )}
          </div>
        </>
      ) : (
        <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>Wybierz okres i kliknij "Odśwież"</div>
      )}
    </div>
  );
}
